import React, { useState, useEffect } from 'react';
import './ProductTypeManager.css';

function ProductTypeManager() {
  const [productTypes, setProductTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    description: ''
  });

  useEffect(() => {
    fetchProductTypes();
  }, []);

  const fetchProductTypes = async () => {
    try {
      const res = await fetch('/api/product-types');
      const data = await res.json();
      setProductTypes(Array.isArray(data) ? data : []);
      setError('');
    } catch (err) {
      setError('Fehler beim Laden der Produkttypen');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddClick = () => {
    setEditingId(null);
    setFormData({
      name: '',
      description: ''
    });
    setShowForm(true);
  };

  const handleEditClick = (productType) => {
    setEditingId(productType._id);
    setFormData({
      name: productType.name || '',
      description: productType.description || ''
    });
    setShowForm(true);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name.trim()) {
      alert('Name ist erforderlich');
      return;
    }

    try {
      const url = editingId
        ? `/api/product-types/${editingId}`
        : '/api/product-types';
      
      const method = editingId ? 'PATCH' : 'POST';
      
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (res.ok) {
        fetchProductTypes();
        setShowForm(false);
        setEditingId(null);
        alert(editingId ? 'Produkttyp aktualisiert' : 'Produkttyp hinzugefügt');
      } else {
        setError('Fehler beim Speichern');
      }
    } catch (err) {
      setError('Fehler: ' + err.message);
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`"${name}" wirklich löschen?`)) {
      return;
    }

    try {
      const res = await fetch(`/api/product-types/${id}`, {
        method: 'DELETE'
      });

      if (res.ok) {
        fetchProductTypes();
        alert('Produkttyp gelöscht');
      } else {
        setError('Fehler beim Löschen');
      }
    } catch (err) {
      setError('Fehler: ' + err.message);
    }
  };

  if (loading) return <div className="product-type-manager"><p>Lädt...</p></div>;

  return (
    <div className="product-type-manager">
      <div className="product-type-header">
        <h2>🏷️ Produkttyp Manager</h2>
        {!showForm && (
          <button className="btn-add-product-type" onClick={handleAddClick}>
            ➕ Neuer Produkttyp
          </button>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      {showForm && (
        <form className="product-type-form" onSubmit={handleFormSubmit}>
          <div className="form-title">
            {editingId ? '✏️ Produkttyp Bearbeiten' : '➕ Neuer Produkttyp'}
          </div>
          
          <div className="form-grid">
            <div className="form-group">
              <label>Name *</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleFormChange}
                placeholder="z.B. Wachstum, Blüte, etc."
                required
              />
            </div>

            <div className="form-group">
              <label>Beschreibung</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleFormChange}
                placeholder="Produkttyp-Beschreibung..."
                rows="3"
              />
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn-save">💾 Speichern</button>
            <button
              type="button"
              className="btn-cancel"
              onClick={() => {
                setShowForm(false);
                setEditingId(null);
              }}
            >
              ❌ Abbrechen
            </button>
          </div>
        </form>
      )}

      <div className="product-types-grid">
        {productTypes.map(productType => (
          <div key={productType._id} className="product-type-card">
            <div className="product-type-card-header">
              <h3>{productType.name}</h3>
            </div>
            
            <div className="product-type-card-body">
              {productType.description && (
                <p className="description">{productType.description}</p>
              )}
            </div>

            <div className="product-type-card-footer">
              <button
                className="btn-edit"
                onClick={() => handleEditClick(productType)}
                title="Bearbeiten"
              >
                ✏️ Bearbeiten
              </button>
              <button
                className="btn-delete"
                onClick={() => handleDelete(productType._id, productType.name)}
                title="Löschen"
              >
                🗑️ Löschen
              </button>
            </div>
          </div>
        ))}
      </div>

      {productTypes.length === 0 && !showForm && (
        <p className="no-product-types">📭 Keine Produkttypen vorhanden</p>
      )}
    </div>
  );
}

export default ProductTypeManager;
